import { useEffect, useState, useRef } from "react";
import { Dropdown, Button, Form } from "react-bootstrap";
import { Search, XLg, ThreeDotsVertical } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchUcrtAuditTrailList } from "../../../store/actions/ucrtsAction";
import TableDesign from "../../common/table/TableDesign";
import Loader from "../../common/loader/Loader";
import moment from "moment";
// import { resetPopup } from "../../../store/reducerSlice/clients";
const tableHeadings = [
  {
    label: "S. No.",
  },
  {
    label: "Geography",
    // sort: "location",
  },

  {
    label: "Entry Date & Time",
    // sort: "entryDate",
  },
  {
    label: "Created Date & Time",
    // sort: "createdAt",
  },

  // {
  //   label: "Updated Date & Time",
  // },

  {
    label: "Operations",
    // sort: "action",
  },
];

const debounce = (func, timeout = 500) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

const UcrtAuditList = () => {
  const [modalShow, setModalShow] = useState(false);
  const [startDate, setStartDate] = useState(
    moment().subtract(3, "d").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [status, setStatus] = useState("all");
  const [selectCondition, setSelectCondition] = useState(null);
  const [selectClient, setSelectClient] = useState(null);
  const [message, setMessage] = useState(null);
  const [title, setTitle] = useState(null);
  const [adate, setADate] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [searchText, setSearchText] = useState();
  const [activeTab, setActiveTab] = useState("");
  const [auditTrailList, setAuditTrailList] = useState("");
  const searchInputRef = useRef(null);
  const [filterOption, setFilterOption] = useState({
    startDate: startDate,
    endDate: endDate,
    // page: 1,
    // search: "",
    orderBy: "updatedAt",
    orderIn: -1,
  });

  const [isShow, setIsShow] = useState(false);
 
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  var todayDate = new Date().toISOString().slice(0, 10);
  const { ucrts,auditTrails, filtered, pagination, isLoader, isRecordUpdated } =
    useSelector((state) => {
      console.log("ucrts",state?.ucrts);
      console.log("state",state);
      return state.ucrts;
    });
  const page = pagination?.currentPage;

  const cc = filtered || ucrts?.auditTrails;
useEffect(()=>{
  console.log("cc",cc)
},[cc])
  useEffect(() => {
    if (location?.state?.previousActiveTab) {
      setActiveTab(location?.state?.previousActiveTab);
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state?.previousActiveTab]);

  useEffect(() => {
    if (activeTab === 1) {
      setStatus("Active");
      filterStatusHandler({ status: "Active", page: 1 });
    } else if (activeTab === 2) {
      filterStatusHandler({ status: "Inactive", page: 1 });
    } else if (activeTab === 3) {
      filterStatusHandler({ status: "Draft", page: 1 });
    }
    // else{
    //     filterStatusHandler({status:'All'})
    // }
  }, [activeTab]);

  // useEffect(() => {
  //   if (searchText || searchText === "") {
  //     filterHandler({ search: searchText, page: 1 });
  //   }
  // }, [searchText]);
  window.history.replaceState({}, document.title);

  useEffect(() => {
    if (!location?.state?.previousActiveTab) {
      dispatch(fetchUcrtAuditTrailList({...filterOption, startDate, endDate}));
    }
  }, [filterOption, isRecordUpdated]);

  const filterStatusHandler = (obj) => {
    let val = { ...filterOption };
    val.status = obj.status;
    setFilterOption({
      ...filterOption,
      ...obj,
    });
  };

  const filterHandler = (obj) => {
    setFilterOption({
      ...filterOption,
      ...obj,
    });
  };

  const formatedDate = (val) => {
    var options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour12: true,
    };
    return new Date(val).toLocaleDateString("nl-NL", options);
  };
  const formatedTime = (val) => {
    var options = { hour12: true, hour: "2-digit", minute: "2-digit" };
    return new Date(val).toLocaleTimeString("en-US", options);
  };
  useEffect(() => {
    console.log("startDate", startDate);
    console.log("endDate", endDate);

    dispatch(
      fetchUcrtAuditTrailList({
        startDate: startDate,
        endDate: endDate,
      })
    ).then(({ payload }) => {
      console.log("payload",payload);
      if (payload.success) {
        setAuditTrailList(payload?.data?.auditTrails);
        hideHandlerRes();
      } else {
        setIsShow(true);
      }
    });
  }, [startDate, endDate]);
  useEffect(() => {
    if (startDate) {
      setADate(new Date(startDate));
    }
  }, [startDate]);
  const hideHandlerRes = () => {
    setIsShow(false);
  };

  return (
    <>
      <div className="container">
        <h1 className="main-title">UCRT Audit Trails</h1>

        <div className="block">
          <div className="date-group" style={{ float: "right" }}>
            <Form.Group style={{ marginRight: "10px" }}>
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                timeFormat="YYYY-MM-DD"
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
                placeholder="Select"
                autoFocus
                name="start_date"
                max={new Date().toISOString().slice(0, 10)}
                defaultValue={startDate}
                onChange={(e) => {
                  console.log("setDatefield-719", e.target.value);

                  setStartDate(e.target.value);
                }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
                placeholder="Select"
                autoFocus
                name="end_date"
                min={startDate}
                max={moment().format("YYYY-MM-DD")}
                defaultValue={endDate}
                onChange={(e) => {
                  console.log("setDatefield-719", e.target.value);

                  setEndDate(e.target.value);
                }}
              />
            </Form.Group>
          </div>

          <div className="searchForm">
            {/* <Search className="searchSvg1" />
            <Form.Control
              type="text"
              name="search"
              ref={searchInputRef}
              placeholder="Search"
              onKeyUp={debounce((e) => setSearchText(e.target.value), 200)}
            />
            {searchText?.length > 0 && (
              <XLg
                className="searchSvg2"
                onClick={(e) => {
                  searchInputRef.current.value = "";
                  setSearchText("");
                }}
              />
            )} */}
          </div>
        </div>

        <TableDesign
          className="mt-5 pt-4"
          {...{
            title: "List of All UCRT Audit Trails",
            tableHeadings,
            filterHandler,
            pagination,
            filterOption,
            setFilterOption,
            isLoader,
          }}
        >
          {isLoader && <Loader />}
          {auditTrailList && auditTrailList.length>0 ? (
            auditTrailList.map((row, i) => {
              if (row)
                return (
                  <tr key={i} className="align-items-center">
                    <td>{i + 1 + (page > 1 && (page - 1) * 10)}</td>
                    <td>{row.locationName}</td>
                    <td>
                      {formatedDate(row.entryDate)},{" "}
                      {formatedTime(row.entryDate)}
                    </td>
                    <td>
                      {formatedDate(row.createdAt)},{" "}
                      {formatedTime(row.createdAt)}
                    </td>
                    {/* <td>
                      {formatedDate(row.updatedAt)},<br/>
                      {formatedTime(row.updatedAt)}
                    </td> */}
                    <td style={{ width: "240px" }}>{row.action}</td>
                    {/* <td>
                      {row.isActivated ? (
                        row.status === "Active" ? (
                          <span style={{ color: "#10940D", fontWeight: 500 }}>
                            Active
                          </span>
                        ) : (
                          <span style={{ color: "red" }}>Inactive</span>
                        )
                      ) : (
                        <span style={{ color: "#F8A80C" }}>Pending</span>
                      )}
                    </td> */}
                  </tr>
                );
            })
          ) : (
            <>
              {!isLoader && (
                <tr>
                  <td colSpan="8">No Result Found</td>
                </tr>
              )}
            </>
          )}
        </TableDesign>
      </div>
    </>
  );
};

export default UcrtAuditList;
